var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-card',[_c('apexchart',{attrs:{"type":"pie","height":"350","options":_vm.config.chartOptions,"series":_vm.graph.data}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }